import { Immutable } from "immer";
import React from "react";

import type { IBaseComponent } from "../../models/formFields";
import { notEmpty } from "../../utils/functional";
import {
    FORM_ERROR_CLASS_NAME,
    FORM_ERROR_LIST_CLASS_NAME,
} from "../classNames";
import { getErrorListElemID, showValidationErrors } from "../hooks/formUtils";

/**
 * Renders validation errors
 *
 * The literal `form__error*` classes stay alongside the module classes while
 * legacy contextual rules still target them (#34958).
 */
export const FormValidationError = (
    props: Immutable<
        IBaseComponent & {
            id?: string;
        }
    >,
): React.ReactNode => {
    const elemID = props.id ? getErrorListElemID(props.id) : undefined;
    const shouldShowErrors = props.errors && showValidationErrors(props);

    if (!elemID && !shouldShowErrors) {
        return null;
    }

    const errors = shouldShowErrors
        ? props.errors.filter(notEmpty).map((msg) => {
              return (
                  <li
                      className={FORM_ERROR_CLASS_NAME}
                      data-testid="form-error"
                      key={msg}
                      dangerouslySetInnerHTML={{ __html: msg }}
                  />
              );
          })
        : null;

    return (
        <ul
            id={elemID}
            className={FORM_ERROR_LIST_CLASS_NAME}
            aria-live="polite"
            data-testid="form-error-list"
        >
            {errors}
        </ul>
    );
};
